import { Typography } from 'iglooform';

interface IHeaderTitle {
  title: string;
  subTitle?: string;
}

const HeaderTitle = ({ title, subTitle }: IHeaderTitle) => {
  return (
    <div style={{ marginBottom: '48px' }}>
      <section>
        <Typography
          level="h1"
          style={{
            display: 'block',
            marginBottom: '8px',
          }}
        >
          {title}
        </Typography>
      </section>
      <section>
        <Typography level="body1" style={{ color: '#666666' }}>
          {subTitle}
        </Typography>
      </section>
    </div>
  );
};

export { HeaderTitle };
